import { Identifiable, unavailability, Unavailability } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { formatDate } from "../utils/formatDate";
import { mapError } from "../utils/mapError";

function updateUnavailability(httpClient: HttpClient) {
  return (
    unavailability: Identifiable<Unavailability>,
    nextUnavailability: Unavailability,
  ) =>
    httpClient
      .sendHttpRequest<Identifiable<Unavailability>>({
        endpoint: `/unavailabilities/${unavailability.uuid}`,
        method: HttpMethods.PATCH,
        data: {
          label: nextUnavailability.label,
          partialUnavailability: nextUnavailability.partialUnavailability,
          nonWorkedHoursCount: nextUnavailability.nonWorkedHoursCount,
          ...(nextUnavailability.startDate && {
            startDate: formatDate(nextUnavailability.startDate),
          }),
          ...(nextUnavailability.endDate && {
            endDate: formatDate(nextUnavailability.endDate),
          }),
          resource: `resources/${nextUnavailability.resource.uuid}`,
          reason: `nextUnavailabilityReasons/${nextUnavailability.reason.uuid}`,
        },
      })
      .then((u) => ({ ...unavailability, ...nextUnavailability, ...u }))
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            invalidUnavailabilityNonWorkedHoursCount:
              "invalidUnavailabilityNonWorkedHoursCount",
            invalidUnavailabilityDates: "invalidUnavailabilityDates",
          }),
        ),
      );
}
export { updateUnavailability };
